import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, BadgeCheck, Check } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PackagesPage() {
  const { user } = useAuth();
  const [packages, setPackages] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/packages").then((r) => setPackages(r.data)).catch(() => {});
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const name = settings?.business_name || "DreamCots";

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-14">
      <p className="nb-label" style={{ letterSpacing: "0.2em" }}>Packages</p>
      <h1 data-testid="packages-heading" className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">Grow faster on {name}</h1>
      <p className="mt-4 text-slate-600 max-w-2xl">
        Free listings include up to 10 students and 5 teachers. Upgrade to a paid package to unlock unlimited
        listings, a trust badge and priority placement in search results.
      </p>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8">
        {packages.length === 0 && <p className="text-sm text-slate-500">No packages available right now.</p>}
        {packages.map((p) => (
          <div key={p.id} data-testid={`packages-card-${p.id}`} className="nb p-8 flex flex-col"
            style={p.badge === "featured" ? { borderColor: "#EAB308", boxShadow: "4px 4px 0 #EAB308" } : {}}>
            <div className="flex items-center gap-2">
              {p.badge === "verified" ? <BadgeCheck className="w-6 h-6 text-blue-500" /> : <Sparkles className="w-6 h-6 text-amber-500" />}
              <h2 className="font-display text-2xl font-extrabold">{p.name}</h2>
            </div>
            <p className="font-display text-4xl font-extrabold mt-5">₹{p.price}<span className="text-sm text-slate-500 font-sans font-normal"> / {p.duration_days} days</span></p>
            <p className="text-sm text-slate-600 mt-3 flex-1">{p.description}</p>
            <ul className="mt-5 space-y-2 text-sm font-semibold">
              {[`${p.badge === "verified" ? "Verified" : "Featured"} badge on your listing`,
                p.badge === "featured" ? "Priority placement at the top of results" : "Trust signal for students & parents",
                "Unlimited student & teacher listings"].map((f) => (
                <li key={f} className="flex items-center gap-2"><Check className="w-4 h-4 text-lime-600" /> {f}</li>
              ))}
            </ul>
            <Link to={user?.role === "institute" ? "/institute" : "/register"} data-testid={`packages-cta-${p.id}`} className="nb-btn nb-btn-lime mt-7 w-full">
              {user?.role === "institute" ? "Upgrade from Dashboard" : "Get Listed & Upgrade"}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
